const paintings4 = [
  {
    id: '4_01',
    name: 'The Korte Vijverberg at The Hague Seen from the Tournooiveld',
    imageSrc: 'level4/4_01.jpg',
    cutSrc: 'level4/cut/4_01.jpg',
    author: 'FARGUE, Jacob Elias La',
    year: '1761',
  },
  {
    id: '4_02',
    name: 'Ideal Landscape near Rocca Canterana',
    imageSrc: 'level4/4_02.jpg',
    cutSrc: 'level4/cut/4_02.jpg',
    author: 'FOHR, Carl Philipp',
    year: '1818',
  },
  {
    id: '4_03',
    name: 'Young Woman and a Herdsman in a Landscape',
    imageSrc: 'level4/4_03.jpg',
    cutSrc: 'level4/cut/4_03.jpg',
    author: 'FRAGONARD, Jean-Honore',
    year: '1765',
  },
  {
    id: '4_04',
    name: 'View of the Falls at Tivoli',
    imageSrc: 'level4/4_04.jpg',
    cutSrc: 'level4/cut/4_04.jpg',
    author: 'FREY, Johannes Jakob',
    year: '1840s',
  },
  {
    id: '4_05',
    name: 'Village Landscape in Morning Light (The Lone Tree)',
    imageSrc: 'level4/4_05.jpg',
    cutSrc: 'level4/cut/4_05.jpg',
    author: 'FRIEDRICH, Caspar David',
    year: '1822',
  },
  {
    id: '4_06',
    name: 'Dolmen in the Snow',
    imageSrc: 'level4/4_06.jpg',
    cutSrc: 'level4/cut/4_06.jpg',
    author: 'FRIEDRICH, Caspar David',
    year: '1807',
  },
  {
    id: '4_07',
    name: 'The Liris Waterfalls near Isola di Sora',
    imageSrc: 'level4/4_07.jpg',
    cutSrc: 'level4/cut/4_07.jpg',
    author: 'FRIES, Ernst',
    year: '1830',
  },
  {
    id: '4_08',
    name: 'River Landscape',
    imageSrc: 'level4/4_08.jpg',
    cutSrc: 'level4/cut/4_08.jpg',
    author: 'GAINSBOROUGH, Thomas',
    year: '1770',
  },
  {
    id: '4_09',
    name: 'Marine View (Seascape with Porpoises)',
    imageSrc: 'level4/4_09.jpg',
    cutSrc: 'level4/cut/4_09.jpg',
    author: 'MANET, Edouard',
    year: '1864',
  },
  {
    id: '4_10',
    name: 'Country House in Rueil',
    imageSrc: 'level4/4_10.jpg',
    cutSrc: 'level4/cut/4_10.jpg',
    author: 'MANET, Edouard',
    year: '1882',
  },
  {
    id: '4_11',
    name: 'The Rialto Bridge from the Riva del Vin',
    imageSrc: 'level4/4_11.jpg',
    cutSrc: 'level4/cut/4_11.jpg',
    author: 'MARIESCHI, Michele',
    year: '1740s',
  },
  {
    id: '4_12',
    name: 'Santa Maria della Salute, Venice',
    imageSrc: 'level4/4_12.jpg',
    cutSrc: 'level4/cut/4_12.jpg',
    author: 'MARIESCHI, Michele',
    year: '1740',
  },
  {
    id: '4_13',
    name: 'Landscape with Charcoal Burners',
    imageSrc: 'level4/4_13.jpg',
    cutSrc: 'level4/cut/4_13.jpg',
    author: 'MARKÓ, András',
    year: '1861',
  },
  {
    id: '4_14',
    name: 'Italian Landscape with Viaduct and Rainbow',
    imageSrc: 'level4/4_14.jpg',
    cutSrc: 'level4/cut/4_14.jpg',
    author: 'MARKÓ, Károly the Elder',
    year: '1838',
  },
  {
    id: '4_15',
    name: 'In the Vicinity of Pisa',
    imageSrc: 'level4/4_15.jpg',
    cutSrc: 'level4/cut/4_15.jpg',
    author: 'MARKÓ, Károly the Younger',
    year: '1878',
  },
  {
    id: '4_16',
    name: 'Ile de Bréhat',
    imageSrc: 'level4/4_16.jpg',
    cutSrc: 'level4/cut/4_16.jpg',
    author: 'MAUFRA, Maxime',
    year: '1892',
  },
  {
    id: '4_17',
    name: 'Kilchurn Castle, Loch Awe',
    imageSrc: 'level4/4_17.jpg',
    cutSrc: 'level4/cut/4_17.jpg',
    author: 'MCCULLOCH, Horatio',
    year: '1854',
  },
  {
    id: '4_18',
    name: 'Under the Cross',
    imageSrc: 'level4/4_18.jpg',
    cutSrc: 'level4/cut/4_18.jpg',
    author: 'MEDNYÁNSZKY, László',
    year: '1892',
  },
  {
    id: '4_19',
    name: 'Landscape Inspired by the View of Frascati',
    imageSrc: 'level4/4_19.jpg',
    cutSrc: 'level4/cut/4_19.jpg',
    author: 'MICHALLON, Achille-Etna',
    year: '1822',
  },
  {
    id: '4_20',
    name: 'The Handelskom at Bruges',
    imageSrc: 'level4/4_20.jpg',
    cutSrc: 'level4/cut/4_20.jpg',
    author: 'MINDERHOUT, Hendrik van',
    year: '1665',
  },
  {
    id: '4_21',
    name: 'Extensive Rhenish Landscape',
    imageSrc: 'level4/4_21.jpg',
    cutSrc: 'level4/cut/4_21.jpg',
    author: 'MINDERHOUT, Hendrik van',
    year: '1653',
  },
  {
    id: '4_22',
    name: 'River Landscape',
    imageSrc: 'level4/4_22.jpg',
    cutSrc: 'level4/cut/4_22.jpg',
    author: 'MIROU, Anton',
    year: '1610s',
  },
  {
    id: '4_23',
    name: 'Woman in the Garden',
    imageSrc: 'level4/4_23.jpg',
    cutSrc: 'level4/cut/4_23.jpg',
    author: 'MONET, Claude',
    year: '1866',
  },
  {
    id: '4_24',
    name: 'On the Bank of the Seine, Bennecourt',
    imageSrc: 'level4/4_24.jpg',
    cutSrc: 'level4/cut/4_24.jpg',
    author: 'MONET, Claude',
    year: '1868',
  },
  {
    id: '4_25',
    name: "Monet's Garden at Argenteuil",
    imageSrc: 'level4/4_25.jpg',
    cutSrc: 'level4/cut/4_25.jpg',
    author: 'MONET, Claude',
    year: '1873',
  },
  {
    id: '4_26',
    name: 'Three Fishing Boats',
    imageSrc: 'level4/4_26.jpg',
    cutSrc: 'level4/cut/4_26.jpg',
    author: 'MONET, Claude',
    year: '1886',
  },
  {
    id: '4_27',
    name: 'Haystacks at Giverny',
    imageSrc: 'level4/4_27.jpg',
    cutSrc: 'level4/cut/4_27.jpg',
    author: 'MONET, Claude',
    year: '1886',
  },
  {
    id: '4_28',
    name: 'Water Lily Pond, Harmony in Rose',
    imageSrc: 'level4/4_28.jpg',
    cutSrc: 'level4/cut/4_28.jpg',
    author: 'MONET, Claude',
    year: '1900',
  },
  {
    id: '4_29',
    name: 'Water Lilies',
    imageSrc: 'level4/4_29.jpg',
    cutSrc: 'level4/cut/4_29.jpg',
    author: 'MONET, Claude',
    year: '1914',
  },
];

export default paintings4;
